import type { ClientNodeData } from './buildGraph';
import { HoverShell } from './HoverShell';

/** Hover de cliente (sección 7.3 del spec): resumen agregado de sus sucursales. */
export function ClientHoverCard({ data, x, y }: { data: ClientNodeData; x: number; y: number }) {
  return (
    <HoverShell x={x} y={y}>
      <div className="font-semibold tracking-tight">{data.label}</div>
      <div className="opacity-70">
        {data.onlineCount} online · {data.offlineCount} offline · {data.unknownCount} desconocido
      </div>
      {data.branchesWithIssues > 0 && (
        <div className="opacity-70">
          {data.branchesWithIssues} de {data.branchCount} sucursales con alertas
        </div>
      )}
    </HoverShell>
  );
}
